module.exports = __webpack_public_path__ + "img/videowiki.a0416487.svg";